<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">مدیرت امتیازات خرید</h5>
        <div class="d-flex align-items-center">
          <button
            :disabled="disabled"
            type="button"
            @click="submitChanges"
            class="btn btn-success ml-2"
          >
            ثبت تغییرات
          </button>
          <button
            v-b-modal.create_purchase_score
            type="button"
            class="btn btn-success"
          >
            افزودن امتیاز جدید
          </button>
        </div>
      </div>
      <div class="card-body">
        <b-form-group class="w-25">
          <div class="d-flex justify-content-between">
            <label> نوع : </label>
          </div>
          <b-form-select
            v-model="type"
            :options="typeOptions"
            @change="loadData"
          ></b-form-select>
        </b-form-group>

        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          small
          v-if="items && items.length"
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(title)="data">
            <b-form-input type="text" v-model="data.item.title" />
          </template>
          <template v-slot:cell(min_value)="data">
            <b-form-input type="number" v-model="data.item.min_value" />
          </template>
          <template v-slot:cell(max_value)="data">
            <b-form-input type="number" v-model="data.item.max_value" />
          </template>
          <template v-slot:cell(bon_value)="data">
            <b-form-input type="number" v-model="data.item.bon_value" />
          </template>
          <template v-slot:cell(score_value)="data">
            <b-form-input type="number" v-model="data.item.score_value" />
          </template>
          <template v-slot:cell(delete)="data">
            <button
              class="btn btn-danger"
              type="button"
              @click="deleteItem(data.item.id)"
            >
              حذف
            </button>
          </template>
        </b-table>
        <div v-else class="alert alert-info">
          موردی یافت نشد
        </div>
      </div>
    </div>
    <CreatePurchaseScore :type="type" @after-add-score="afterAddScore" />
  </main>
</template>
<script>
import purchaseScoreSettingsImpl from "@@/core/pages/customerClub/clubSettings/purchaseScoreSettings/purchaseScoreSettingsImpl.js";
export default {
    extends: purchaseScoreSettingsImpl,
};
</script>